import {
  FETCH_HOSPITAL_FAIL,
  FETCH_HOSPITAL_REQUEST,
  FETCH_HOSPITAL_SUCCESS,
  UPDATE_HOSPITAL_FAIL,
  UPDATE_HOSPITAL_REQUEST,
  UPDATE_HOSPITAL_SUCCESS,
} from "../../ActionType/HospitalType/HospitalType";
import { api } from "../../Api/api";
import { getToken } from "../login";
import swal from "sweetalert";

export const getHospitalAction =
  (page, perPage, search) => async (dispatch) => {
    try {
      console.log(search)
      const config = {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
        params: {
          page,
          perPage,
          search,
        },
      };
      dispatch({ type: FETCH_HOSPITAL_REQUEST });
      const res = await api.get("hospital", config);
      // console.log(res)
      if (res.status === 200) {
        dispatch({
          type: FETCH_HOSPITAL_SUCCESS,
          payload: { data: res.data.data.data, total: res.data.data.total },
        });
      }
    } catch (error) {
      dispatch({ type: FETCH_HOSPITAL_FAIL, payload: error });
    }
  };
export const createHospitalAction = (formData, status) => async (dispatch) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    };



    const branchId = formData.branchId.value || formData.branchId
    dispatch({ type: FETCH_HOSPITAL_REQUEST });
    const res = await api.post(
      "hospital",
      { name: formData.name, status, branch_id: branchId },
      config
    );

    if (res.status === 200) {
      dispatch(getHospitalAction(1, 10, null));
      dispatch(getHospitalAction(1, 10, null));
      dispatch({ type: FETCH_HOSPITAL_SUCCESS, payload: res.data });
      swal({
        title: "Good job!",
        text: "Hospital created successfully",
        icon: "success",
        button: "OK",
        timer: 2000,
      });
    }
  } catch (error) {
    console.log(error);
    dispatch({ type: FETCH_HOSPITAL_FAIL, payload: error });
  }
};

export const updateHospitalAction =
  (id, formData, status) => async (dispatch) => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      };
      // console.log(formData.branchId)
      const branchId = formData.branchId.value || formData.branchId;
      dispatch({ type: UPDATE_HOSPITAL_REQUEST });
      const res = await api.put(
        "hospital/" + id,
        { name: formData.name, status, branch_id: branchId },
        config
      );

      if (res.status === 200) {
        dispatch({ type: UPDATE_HOSPITAL_SUCCESS, payload: res.data });
        dispatch(getHospitalAction(1, 10, null));
        dispatch(getHospitalAction(1, 10, null));
        swal({
          title: "Good job!",
          text: "Hospital updated successfully",
          icon: "success",
          button: "OK",
          timer: 2000,
        });
      }
    } catch (error) {
      console.log(error);
      dispatch({ type: UPDATE_HOSPITAL_FAIL, payload: error });
    }
  };

export const deleteHospitalAction = (id) => async (dispatch) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    };
    dispatch({ type: UPDATE_HOSPITAL_REQUEST });
    const res = await api.delete(
      "hospital/" + id,
      config
    );

    if (res.status === 200) {
      dispatch({ type: UPDATE_HOSPITAL_SUCCESS, payload: res.data });
      dispatch(getHospitalAction(1, 10, null));
      dispatch(getHospitalAction(1, 10, null));
      swal({
        title: "Good job!",
        text: "Hospital Deleted successfully",
        icon: "success",
        button: "OK",
        timer: 2000,
      });
    }
  } catch (error) {
    console.log(error);
    dispatch({ type: UPDATE_HOSPITAL_FAIL, payload: error });
  }
};
